<section class="relative flex flex-col items-center gap-6">
  <div
    class="absolute h-full w-full bg-[radial-gradient(#d1d5db_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_85%,transparent_100%)]"
  ></div>
  <div class="z-10 flex flex-col items-center gap-14">
    <h1 class="text-center text-4xl font-bold leading-relaxed md:text-5xl">
      @defer {
        The #1 alternative to<br /><span
          [roughNotation]="{
            animate: true,
            animationDelay: 500,
            strokeWidth: 3,
            iterations: 4,
            type: 'underline',
            color: 'var(--tui-background-accent-2)',
            padding: 2,
          }"
          >Capgo</span
        >
      } @placeholder {
        The #1 alternative to<br />Capgo
      }
    </h1>
    <p class="w-full text-balance text-center text-xl leading-snug md:w-3/4">
      Production-ready Native Builds, automated App Store Publishing, and
      reliable Live Updates — all in one platform with expert support.
    </p>
    <div class="flex space-x-4">
      <a
        iconEnd="@tui.arrow-right"
        size="l"
        tuiButton
        type="button"
        [href]="consoleBaseUrl"
        target="_blank"
        data-umami-event="compare-capgo-hero-start-free-button"
      >
        Start for free
      </a>
      <a
        appearance="secondary"
        size="l"
        tuiButton
        type="button"
        [href]="bookingUrl"
        target="_blank"
        data-umami-event="compare-capgo-hero-booking-demo-button"
      >
        Book a demo
      </a>
    </div>
  </div>
</section>
